const PD_ALERT_TITLE_LABEL = 'products.glasses.prescription.form.pdAlertTitle';
const PD_ALERT_MESSAGE_LABEL = 'products.glasses.prescription.form.pdAlertMessage';

export { PD_ALERT_MESSAGE_LABEL, PD_ALERT_TITLE_LABEL };
//# sourceMappingURL=types.js.map
